import React from "react";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import MuiAlert from "@mui/material/Alert";

interface ToastProps {
  open: boolean;
  message: string;
  loading: boolean;
  onClose: () => void;
}

const LoaderToast: React.FC<ToastProps> = ({
  open,
  message,
  loading,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={60000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <MuiAlert
        onClose={onClose}
        severity={loading ? "info" : "success"}
        sx={{ display: "flex", alignItems: "center" }}
      >
        {loading && <CircularProgress size={20} sx={{ marginRight: 1 }} />}
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default LoaderToast;
